import { render, staticRenderFns } from "./weaver.vue?vue&type=template&id=7f143a7d&"
import script from "./weaver.vue?vue&type=script&lang=js&"
export * from "./weaver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports